export default __webpack_public_path__ + "static/use-body-text-dont-008da938111df66115a37036a5581b46.png";